import Api from 'api'

const config = {
  baseURL: '/api/app/v1/anl',
}
const api = new Api(config)

api.fetchHierarchy = ({ external_id }) =>
  api.get(`/google-analytics/${external_id}/profiles-hierarchy`)

export default api
